import React from 'react';

/** Compact inline SVG flags — crisp on all platforms (no emoji). */
const FLAGS = {
  br: (
    <svg viewBox="0 0 28 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="28" height="20" rx="2" fill="#009B3A" />
      <path fill="#FEDF00" d="M14 2.4 25.2 10 14 17.6 2.8 10Z" />
      <circle cx="14" cy="10" r="4.15" fill="#002776" />
      <path
        fill="none"
        stroke="#fff"
        strokeWidth="0.85"
        d="M10.15 11.35c1.55-1.7 3.9-2.55 6.55-2.2"
      />
    </svg>
  ),
  us: (
    <svg viewBox="0 0 28 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="28" height="20" rx="2" fill="#B22234" />
      <path
        fill="#fff"
        d="M0 2.22h28v1.54H0zm0 3.08h28v1.54H0zm0 3.08h28v1.54H0zm0 3.08h28v1.54H0zm0 3.08h28v1.54H0z"
      />
      <rect width="11.2" height="10.77" rx="1" fill="#3C3B6E" />
      <g fill="#fff">
        <circle cx="2" cy="2.2" r="0.55" />
        <circle cx="4.2" cy="2.2" r="0.55" />
        <circle cx="6.4" cy="2.2" r="0.55" />
        <circle cx="8.6" cy="2.2" r="0.55" />
        <circle cx="3.1" cy="3.7" r="0.55" />
        <circle cx="5.3" cy="3.7" r="0.55" />
        <circle cx="7.5" cy="3.7" r="0.55" />
        <circle cx="2" cy="5.2" r="0.55" />
        <circle cx="4.2" cy="5.2" r="0.55" />
        <circle cx="6.4" cy="5.2" r="0.55" />
        <circle cx="8.6" cy="5.2" r="0.55" />
        <circle cx="3.1" cy="6.7" r="0.55" />
        <circle cx="5.3" cy="6.7" r="0.55" />
        <circle cx="7.5" cy="6.7" r="0.55" />
        <circle cx="2" cy="8.2" r="0.55" />
        <circle cx="4.2" cy="8.2" r="0.55" />
        <circle cx="6.4" cy="8.2" r="0.55" />
        <circle cx="8.6" cy="8.2" r="0.55" />
      </g>
    </svg>
  ),
};

/**
 * @param {{ code: 'br' | 'us', className?: string }} props
 */
const FlagIcon = ({ code, className = '' }) => {
  const flag = FLAGS[code];
  if (!flag) return null;
  return (
    <span className={`lang-flag${className ? ` ${className}` : ''}`}>{flag}</span>
  );
};

export default FlagIcon;
